import { render } from "./AppFooter.vue?vue&type=template&id=3d4cb147&bindings={\"year\":\"options\"}"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"
script.render = render

export default script